import { Money, USD } from '@contra/money';
import { createContext } from 'react';

export type ContraBalance = {
  availableCents: number;
  locked: USD;
  processing: USD;
  totalCents: number;
};

export type ContraPaymentsContextType = {
  balance: ContraBalance;
  payoutMethods: PayoutMethod[];
};

export type PayoutMethod = {
  canWithdraw: boolean;
  currency: string;
  id: string;
  isDefault: boolean;
  label: string;
  last4: string;
  type:
    | 'AIRWALLEX_BENEFICIARY'
    | 'BANK_ACCOUNT'
    | 'CARD'
    | 'CRYPTO_ADDRESS'
    | 'PAYONEER'
    | 'PAYPAL';
};

export const initialContext: ContraPaymentsContextType = {
  balance: {
    availableCents: 0,
    locked: Money.fromUsdDollars(0),
    processing: Money.fromUsdDollars(0),
    totalCents: 0,
  },
  payoutMethods: [],
};

export const ContraPaymentsContext =
  createContext<ContraPaymentsContextType>(initialContext);
